/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mateus Furrier",
  title: "Olá, sou Mateus Furrier",
  titleEn: "Hi, I'm Mateus Furrier",
  subTitle: (
    "Arquiteto de Soluções Enterprise com 19+ anos projetando e entregando sistemas enterprise — de integrações SAP B1 e plataformas de compras a implementações SIEM e programas ISO 27001. Lidero um time multidisciplinar de 8 pessoas em uma multinacional francesa do agronegócio, conectando ERP, cibersegurança e engenharia full-stack moderna."
  ),
  subTitleEn: (
    "Enterprise Solutions Architect with 19+ years designing and delivering enterprise-grade systems — from SAP Business One integrations and procurement platforms to SIEM implementations and ISO 27001 programs. I lead a multidisciplinary team of 8 at a French agribusiness multinational, bridging the gap between ERP, cybersecurity, and modern full-stack engineering."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1QSVJ9p0UIvLPtRSMAgvp4-ebeTzpBNoa/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/matfurrier",
  linkedin: "https://www.linkedin.com/in/mateusfurrier/?locale=pt_BR",
  gmail: "matfurrier@gmail.com",
  gitlab: "https://gitlab.com/matfurrier",
  website: "https://www.furrierlabs.com.br",
  whatsapp: "https://wa.me/5543999242485",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Tech Stack",
  skills: [
    emoji("🏗️ Arquitetura e integração de sistemas enterprise com SAP Business One"),
    emoji("🧩 Desenvolvimento back-end com FastAPI, Node.js e Python"),
    emoji("🌐 Integrações via REST/SOAP APIs, Kafka e N8N"),
    emoji("☁️ Cloud & DevOps com Docker, Kubernetes e CI/CD"),
    emoji("🔒 Cibersegurança, ISO 27001, LGPD/DPO e implementações SIEM"),
    emoji("📊 BI, dashboards e forecasting com Next.js, Qlik e D3.js"),
    emoji("🤖 Agentes de IA e automação de processos com LLMs")
  ],
  skillsEn: [
    emoji("🏗️ Enterprise system architecture and SAP Business One integration"),
    emoji("🧩 Back-end development with FastAPI, Node.js and Python"),
    emoji("🌐 REST/SOAP API integrations, Kafka and N8N"),
    emoji("☁️ Cloud & DevOps with Docker, Kubernetes and CI/CD"),
    emoji("🔒 Cybersecurity, ISO 27001, LGPD/DPO and SIEM implementations"),
    emoji("📊 BI, dashboards and forecasting with Next.js, Qlik and D3.js"),
    emoji("🤖 AI agents and process automation with LLMs")
  ],

  softwareSkills: [
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "FastAPI", fontAwesomeClassname: "fab fa-python" },
    { skillName: "TypeScript", fontAwesomeClassname: "fas fa-code" },
    { skillName: "React", fontAwesomeClassname: "fab fa-react" },
    { skillName: "Linux", fontAwesomeClassname: "fab fa-linux" },
    { skillName: "PostgreSQL", fontAwesomeClassname: "fas fa-database" },
    { skillName: "Docker", fontAwesomeClassname: "fab fa-docker" },
    { skillName: "SAP Business One", fontAwesomeClassname: "fas fa-briefcase" }
  ],

  display: true
};


const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "MBA Em Cyber Security - Governance & Management",
      schoolNameEn: "MBA in Cyber Security - Governance & Management",
      logo: require("./assets/images/fiapLogo.png"),
      subHeader: "2023-2024 | FIAP",
      subHeaderEn: "2023-2024 | FIAP (São Paulo, Brazil)",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Academia SAP Business One",
      schoolNameEn: "SAP Business One Academy",
      logo: require("./assets/images/uppertoolsLogo.png"),
      subHeader: "2022 | Uppertools",
      subHeaderEn: "2022 | Uppertools",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Licenciatura Em Matemática",
      schoolNameEn: "Mathematics Degree",
      logo: require("./assets/images/cruzeiroLogo.png"),
      subHeader: "2016-2017 | Universidade Cruzeiro Do Sul",
      subHeaderEn: "2016-2017 | Cruzeiro do Sul University",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Pós-Graduação Em Engenharia De Software",
      schoolNameEn: "Software Engineering Post-Graduation",
      logo: require("./assets/images/unifilLogo.png"),
      subHeader: "2011-2012 | UNIFIL - Centro Universitário Filadélfia",
      subHeaderEn: "2011-2012 | UNIFIL - Filadélfia University Center (Londrina, Brazil)",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    },
    {
      schoolName: "Engenharia Da Computação",
      schoolNameEn: "Computer Engineering",
      logo: require("./assets/images/unoparLogo.png"),
      subHeader: "2001-2005 | UNOPAR - Universidade Norte Do Paraná",
      subHeaderEn: "2001-2005 | UNOPAR - North Paraná University (Northern Paraná, Brazil)",
      desc: "",
      descEn: "",
      descBullets: [],
      descBulletsEn: []
    }
  ]
};


// Some big projects you have worked on

const bigProjects = {
  title: "Projetos",
  titleEn: "Projects",
  subtitle: "Alguns Projetos Desenvolvidos Por Mim",
  subtitleEn: "Some Projects Developed By Me",
  projects: [
    {
      image: require("./assets/images/executive-dashboard.png"),
      projectName: "Executive Dashboard",
      projectDesc: "Dashboard financeiro executivo para decisões de nível C. KPIs em tempo real entre entidades, drill-down por centro de custo e visões comparativas sem planilhas intermediárias. Integração com SAP B1.",
      projectDescEn: "Executive financial dashboard for C-level decision-making. Real-time KPIs across entities, drill-down by cost center, comparative views without intermediate spreadsheets. SAP B1 integration.",
      stack: ["Next.js", "PostgreSQL", "SAP B1 Service Layer", "Recharts"],
      role: "Arquitetura & implementação",
      roleEn: "Architecture & implementation",
      footerLink: [
        { name: "Ver no site", nameEn: "View site", url: "https://furrierlabs.com.br/executive-dashboard" },
        { name: "Ver no GitHub", nameEn: "View on GitHub", url: "https://github.com/matfurrier/QlikDashboard" }
      ]
    },
    {
      image: require("./assets/images/agro360.png"),
      projectName: "Agro360",
      projectDesc: "Plataforma de compliance EUDR para exportadores agrícolas. Rastreabilidade da cadeia de suprimentos, due diligence automatizada e relatórios prontos para a regulação da UE.",
      projectDescEn: "EUDR compliance platform for agricultural exporters. Supply-chain traceability, automated due diligence, EU-regulation-ready reports.",
      stack: ["FastAPI", "Next.js", "PostgreSQL", "pgvector"],
      role: "Arquiteto & engenheiro solo",
      roleEn: "Solo architect & engineer",
      footerLink: [{ name: "Ver no site", nameEn: "View site", url: "https://furrierlabs.com.br/agro360" }]
    },
    {
      image: require("./assets/images/boardadvisor.png"),
      projectName: "BoardAdvisor",
      projectDesc: "SaaS de planejamento estratégico guiado por IA. Fluxo de planejamento facilitado em 7 etapas com análise assistida por LLM e entregáveis estruturados para executivos.",
      projectDescEn: "AI-guided strategic planning SaaS. 7-step facilitated planning flow with LLM-assisted analysis and structured deliverables for executives.",
      stack: ["Next.js", "FastAPI", "Claude API", "PostgreSQL"],
      role: "Fundador & único engenheiro",
      roleEn: "Founder & sole engineer",
      footerLink: [{ name: "Ver no GitHub", nameEn: "View on GitHub", url: "https://github.com/matfurrier/BoardAdvisorApp" }]
    },
    {
      image: require("./assets/images/flowcore.png"),
      projectName: "FlowCore — Workflow Engine",
      projectDesc: "Motor de workflows genérico schema-driven em produção para processos de qualidade e RH. Roteamento de etapas inspirado em BPMN, controle de acesso por papéis, trilha de auditoria e fan-out de notificações. Auditável, determinístico, 40% mais rápido nos ciclos.",
      projectDescEn: "Generic schema-driven workflow engine in production for quality and HR processes. BPMN-inspired stage routing, role-based access, audit trail, notification fan-out. Auditable, deterministic, 40% faster cycles.",
      stack: ["FastAPI", "Next.js", "PostgreSQL", "MinIO"],
      role: "Arquiteto & engenheiro líder",
      roleEn: "Architect & lead engineer",
      footerLink: [{ name: "Ver no GitHub", nameEn: "View on GitHub", url: "https://github.com/matfurrier/flowcoreapp" }]
    },
    {
      image: require("./assets/images/ssomanager.png"),
      projectName: "SSO Manager",
      projectDesc: "Ferramenta interna de administração de SSO para Keycloak — sincronização de grupos, mapeamento de papéis, logs de auditoria e provisionamento de acesso multi-aplicação entre aplicações internas.",
      projectDescEn: "Internal SSO administration tool for Keycloak — group sync, role mapping, audit logs, multi-app access provisioning across internal applications.",
      stack: ["Keycloak", "Next.js", "FastAPI"],
      role: "Arquitetura & implementação",
      roleEn: "Architect & implementation",
      footerLink: [{ name: "Ver no GitHub", nameEn: "View on GitHub", url: "https://github.com/matfurrier/ssomanager" }]
    },
    {
      image: require("./assets/images/procurempv.png"),
      projectName: "Procurement Workflow MVP",
      projectDesc: "MVP de fluxo de compras interno — processo de aprovação multi-etapas, controle de acesso por papéis e integração com ERP financeiro. Construído com FastAPI + Next.js + PostgreSQL.",
      projectDescEn: "Internal procurement workflow MVP — multi-stage approval process, role-based access, integration with finance ERP. Built with FastAPI + Next.js + PostgreSQL.",
      stack: ["FastAPI", "Next.js", "PostgreSQL"],
      role: "Arquitetura & implementação",
      roleEn: "Architect & implementation",
      footerLink: [{ name: "Ver no GitHub", nameEn: "View on GitHub", url: "https://github.com/matfurrier/procure-mvp-demo" }]
    }
  ],
  display: true
};



const workExperiences = {
  display: true,
  experience: [
    {
      role: "IT Manager & Solutions Architect",
      roleEn: "IT Manager & Solutions Architect",
      company: "Multinacional francesa do agronegócio",
      companyEn: "French agribusiness multinational",
      date: "Out 2017 – Atual",
      dateEn: "Oct 2017 – Present",
      desc: "Lidero um time multidisciplinar de 8 engenheiros. Arquitetura e implementação de sistemas corporativos internos e integrações profundas com SAP B1. Construí sistemas de IA agêntica com Claude API e servidores MCP. Orquestração de containers com Docker, Kubernetes e Traefik. Conduzo programas de cibersegurança corporativa: SIEM, simulação de phishing, MFA, Keycloak SSO, alinhamento ISO 27001 e compliance LGPD como DPO designado.",
      descEn: "Lead a multidisciplinary team of 8 engineers. Architecture and implementation of internal enterprise systems and SAP B1 deep integrations. Built agentic AI systems with Claude API and MCP servers. Container orchestration with Docker, Kubernetes, and Traefik. Run enterprise cybersecurity programs: SIEM, phishing simulation, MFA, Keycloak SSO, ISO 27001 alignment, GDPR-equivalent (Brazilian LGPD) compliance as appointed DPO.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Sistemas / DBA",
      roleEn: "Systems Analyst / DBA",
      company: "Serilon Brasil",
      companylogo: require("./assets/images/serilonLogo.png"),
      date: "Mai 2011 – Out 2017",
      dateEn: "May 2011 – Oct 2017",
      desc: "Implantação do ERP Dynamics AX, integração de sistemas, desenvolvimento de dashboards no QlikView e Salesforce, modelagem de processos e administração do banco SQL Server. Gestão de infraestrutura e segurança da informação.",
      descEn: "Dynamics AX ERP implementation, system integration, dashboard development in QlikView and Salesforce, process modeling and SQL Server database administration. Infrastructure and information security management.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Suporte",
      roleEn: "Support Analyst",
      company: "Colégio Marista De Londrina",
      companylogo: require("./assets/images/maristaLogo.png"),
      date: "Mai 2009 – Mai 2011",
      dateEn: "May 2009 – May 2011",
      desc: "Administração de parque computacional, suporte a usuários, backup, servidores, rede e telefonia. Documentação e padronização de processos.",
      descEn: "Computer park administration, user support, backup, servers, network and telephony. Documentation and process standardization.",
      descBullets: [],
      descBulletsEn: []
    },
    {
      role: "Analista De Sistemas",
      roleEn: "Systems Analyst",
      company: "Colégio Maxi De Londrina",
      companylogo: require("./assets/images/maxiLogo.png"),
      date: "Dez 2005 – Dez 2008",
      dateEn: "Dec 2005 – Dec 2008",
      desc: "Responsável pela infraestrutura de TI, suporte ao usuário e administração do ERP. Gestão de rede e telefonia com documentação técnica.",
      descEn: "Responsible for IT infrastructure, user support and ERP administration. Network and telephony management with technical documentation.",
      descBullets: [],
      descBulletsEn: []
    }
  ]
};


const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};



// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  titleEn: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",
  subtitleEn:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      titleEn: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      subtitleEn:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          nameEn: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          nameEn: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          nameEn: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      titleEn: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      subtitleEn:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          nameEn: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },
    {
      title: "PWA Web App Developer",
      titleEn: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      subtitleEn: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", nameEn: "Certification", url: "" },
        {
          name: "Final Project",
          nameEn: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  titleEn: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  subtitleEn:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      titleEn: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
      descriptionEn:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      titleEn: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
      descriptionEn:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  titleEn: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),
  subtitleEn: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      titleEn: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      subtitleEn: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  titleEn: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  subtitleEn: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contato ☎️"),
  titleEn: emoji("Contact ☎️"),
  subtitle:
    "Aberto a vagas sênior de engenharia e gestão de engenharia — remoto, PJ ou CLT.",
  subtitleEn:
    "Open to senior engineering and engineering management roles — full-time remote, PJ or full employment.",
  number: "+55-43-99924-2485",
  email_address: "matfurrier@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
